import React from 'react';
import Config from '../config';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Spinner from '../shared/spinner.component';
import FileUploadButton from '../shared/fileUpload/fileUploadButton.component';

import { fetchProvisionData, showAlert } from '../shared/store/actions';
import alertTypes from '../shared/alertTypes';

import { showJobErrorsModal } from '../menu/jobsMenu/store/actions';
import {
  isLastJobOfTypeFinishedSelectorFactory,
  progressOfLastJobOfTypeSelectorFactory,
} from '../shared/jim/store/selectors';
import { successNotification, errorNotification } from '../shared/store/notificationActions';
import { useOnJimJobFail, useOnJimJobSuccess } from '../shared/jim/hooks';
import { acceptedExcelFileExtensions } from '../shared/fileUpload/constants';

const progressSelector = progressOfLastJobOfTypeSelectorFactory(Config.jimJobs.trialBalanceImport.type);
const isLastJobOfTypeFinishedSelector = isLastJobOfTypeFinishedSelectorFactory(Config.jimJobs.trialBalanceImport.type);

const TrialBalanceErrorAlert = ({ showErrors, errors }) => (
  <div className="trial-balance-error-alert">
    <span>Upload failed </span>
    <span
      className="trial-balance-error-link"
      onClick={() => showErrors(errors)} // eslint-disable-line react/jsx-no-bind
    >
      click here to see details
    </span>
  </div>
);
TrialBalanceErrorAlert.propTypes = {
  showErrors: PropTypes.func.isRequired,
  errors: PropTypes.string,
};

const UploadTrialBalanceButton = ({
  cannotUploadTrialBalance,
  showCannotUploadMessageModal,
  hasAccess,
  progress,
  uploadTrialBalanceFile,
  isUploadingTrialBalance,
  fetchProvisionData,
  companyCode,
  successNotification,
  errorNotification,
  showAlert,
  showJobErrorsModal,
}) => {
  useOnJimJobSuccess(Config.jimJobs.trialBalanceImport.type, () => {
    successNotification('Trial Balance File Upload Successful');
    fetchProvisionData(companyCode);
  });

  useOnJimJobFail(Config.jimJobs.trialBalanceImport.type, job => {
    errorNotification('Trial Balance File Upload Failed');
    showAlert(
      (
        <TrialBalanceErrorAlert
          showErrors={showJobErrorsModal}
          errors={job.returnedError}
        />
      ),
      alertTypes.DANGER
    );
  });


  if (!hasAccess) {
    return null;
  }

  if (cannotUploadTrialBalance) {
    return (
      <button
        className="hamburger-action link-button sub-nav-link"
        tabIndex="0"
        onClick={showCannotUploadMessageModal}
      >
        Upload Trial Balance
      </button>
    );
  }

  return (
    <FileUploadButton
      accept={acceptedExcelFileExtensions}
      className="upload-file-button hamburger-action sub-nav-link"
      onChange={uploadTrialBalanceFile}
      disabled={!companyCode}
    >
      {isUploadingTrialBalance
        ? (
          <span>
            <Spinner small/> Loading {progress} %
          </span>
        )
        : 'Upload Trial Balance'
      }
    </FileUploadButton>
  );
};

UploadTrialBalanceButton.propTypes = {
  cannotUploadTrialBalance: PropTypes.bool.isRequired,
  showCannotUploadMessageModal: PropTypes.func.isRequired,
  hasAccess: PropTypes.bool.isRequired,
  progress: PropTypes.number.isRequired,
  uploadTrialBalanceFile: PropTypes.func.isRequired,
  isUploadingTrialBalance: PropTypes.bool.isRequired,
  fetchProvisionData: PropTypes.func.isRequired,
  companyCode: PropTypes.string.isRequired,
  columnMapping: PropTypes.any, // eslint-disable-line react/forbid-prop-types
  successNotification: PropTypes.func.isRequired,
  errorNotification: PropTypes.func.isRequired,
  showAlert: PropTypes.func.isRequired,
  showJobErrorsModal: PropTypes.func.isRequired,
};

export default connect(state => ({
  isUploadingTrialBalance: !isLastJobOfTypeFinishedSelector(state),
  progress: progressSelector(state),
}), {
  fetchProvisionData,
  showAlert,
  successNotification,
  errorNotification,
  showJobErrorsModal,
})(UploadTrialBalanceButton);
